<template>
  <div :class="$style.wraper">
    <div :class="$style.cover">
      <v-responsive :aspectRatio="232 / 137">
        <nuxt-link :to="`/company/article/${report.no}`" target="_blank" :title="report.title">
          <el-image :class="$style.coverImg" class="rounded-t-md" fit="cover" lazy :src="report.cover"
            :alt="report.title" />
          <img src="~/assets/img/company/player-icon.png" v-if="isVideo" class="w-6 h-6 absolute bottom-2 right-2"/>
        </nuxt-link>
      </v-responsive>
    </div>
    <div :class="$style.content">
      <h3 :class="$style.title">
        <nuxt-link :to="`/company/article/${report.no}`" target="_blank" :title="report.title">{{
          report.title
        }}</nuxt-link>
      </h3>
      <div :class="$style.footer">
        <nuxt-link :to="`/company/article/${report.no}`" target="_blank" :title="report.title" class="w-full">
          <div class="flex h-[18px]" :style="{ justifyContent: 'space-between' }">
            <div :class="$style.author">
              <el-avatar :class="$style.authorLogo" shape="circle" :src="report.author_photo" />
              <span :class="$style.authorName">{{ report.author_name }}</span>
            </div>
            <div v-if="report.pageviews > 0">{{ report.pageviews }}次阅读</div>
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
import VResponsive from "@/components/VResponsive/VResponsive.vue";
export default {
  components: { VResponsive },
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
    isVideo :{
      type:Boolean,
      default:false
    }
  },
};
</script>
<style lang="scss" module>
.wraper {
  --tw-border-opacity: 1;
  border-color: rgba(235, 239, 243, var(--tw-border-opacity));
  border-radius: 0.25rem;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding-bottom: 0.75rem;
  -webkit-transition-property: -webkit-box-shadow;
  -o-transition-property: box-shadow;
  transition-property: box-shadow, -webkit-box-shadow;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.recommendTag {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 65, 59, var(--tw-bg-opacity));
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  position: absolute;
  left: 0px;
  top: 1rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.cover {
  margin: -1px;
  position: relative;
}
.coverImg {
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
}
.content {
  padding-left: 15px;
  padding-right: 15px;
}
.author {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  margin-top: -12px;
  position: relative;
  z-index: 1;
}
.authorLogo {
  height: 17px;
  width: 17px;
}
.authorName {
  margin-left: 0.25rem;
  font-size: 12px;
  color: #ACAEBC;
}
.title {
  font-weight: 600;
  height: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 1.25rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 14px;
  color: $color-black-2;
}
.title:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 0.5rem;
  margin-top: auto;
  font-size: 12px;
  color: #ACAEBC;
}
</style>